/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import React, {CSSProperties, MouseEventHandler, ReactElement, useContext, useMemo} from 'react';
import {HeaderItem} from "../../util/interfaces";
import {ControlContext} from "../../util/controlContext";
import classNames from 'classnames';

interface Props {
    onClickItem: (item: HeaderItem) => MouseEventHandler;
    leftItems?: Array<HeaderItem>;
    rightItems?: Array<HeaderItem>;
    backgroundColor?: string;
    color?: string;
    className?: string;
    itemClassName?: string;
}

export default function DvrdHeader(props: Props) {
    const context = useContext(ControlContext);
    const {backgroundColor, color, className, itemClassName, rightItems, onClickItem, leftItems} = props;
    const containerStyle: CSSProperties = useMemo(() => {
        const background = backgroundColor ?? context.baseColor;
        return {backgroundColor: background};
    }, [context.baseColor, backgroundColor]);
    const itemStyle: CSSProperties = useMemo(() => {
        const _color = color ?? context.contrastColor;
        return {color: _color};
    }, [context.contrastColor, color]);

    function renderItem(item: HeaderItem, index: number) {
        const {label} = item;
        if (React.isValidElement(label))
            return React.cloneElement(label,
                Object.assign((label as ReactElement<any>).props, {onClick: onClickItem(item), key: index}));
        return (
            <div key={index} className={classNames('dvrd-header-item', itemClassName)} onClick={onClickItem(item)}
                 style={itemStyle}>
                <label className='dvrd-header-label'>{label}</label>
            </div>
        )
    }

    return (
        <div className={classNames('dvrd-header', className)} style={containerStyle}>
            <div className='dvrd-header-items-container'>
                {leftItems?.map(renderItem)}
            </div>
            <div className='dvrd-header-items-container'>
                {rightItems?.map(renderItem)}
            </div>
        </div>
    )
}